/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Highlight_Previous_EventInputs */

const en_shortcut_keys_name_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highlight Previous Event`)
};

const fr_shortcut_keys_name_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter l'evenement precedent a la selection`)
};

const de_shortcut_keys_name_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorheriges Ereignis hervorheben`)
};

const it_shortcut_keys_name_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidenzia evento precedente`)
};

const ru_shortcut_keys_name_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выделить предыдущее событие`)
};

const es_shortcut_keys_name_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacar evento anterior`)
};

const zh_cn2_shortcut_keys_name_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回顾上一活动`)
};

const ja_shortcut_keys_name_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のイベントをハイライト`)
};

const hi_shortcut_keys_name_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछली घटना को हाइलाइट करें`)
};

const pt_pt2_shortcut_keys_name_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destaque do evento anterior`)
};

/**
* | output |
* | --- |
* | "Highlight Previous Event" |
*
* @param {Shortcut_Keys_Name_Highlight_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_highlight_previous_event = /** @type {((inputs?: Shortcut_Keys_Name_Highlight_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Highlight_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_highlight_previous_event(inputs)
	if (locale === "de") return de_shortcut_keys_name_highlight_previous_event(inputs)
	if (locale === "it") return it_shortcut_keys_name_highlight_previous_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_highlight_previous_event(inputs)
	if (locale === "es") return es_shortcut_keys_name_highlight_previous_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_highlight_previous_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_highlight_previous_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_highlight_previous_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_highlight_previous_event(inputs)
	return en_shortcut_keys_name_highlight_previous_event(inputs)
});